import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import EmptyState from '@atlaskit/empty-state/empty-state';

// @ts-ignore
import ErrorImage from '../../assets/error-state-image.png';
import { messages } from './messages';
import * as Styled from './styles';

export const ReportingLinesErrorState = (): React.JSX.Element => {
	return (
		<Styled.ErrorStateContainer testId="reporting-lines-error-state">
			<EmptyState
				header={messages.ErrorStateHeading.defaultMessage}
				description={messages.ErrorStateMessage.defaultMessage}
				headingLevel={2}
				primaryAction={
					<Button appearance="primary" onClick={() => window.location.reload()}>
						<FormattedMessage {...messages.RefreshButton} />
					</Button>
				}
				imageUrl={ErrorImage}
			/>
		</Styled.ErrorStateContainer>
	);
};
